import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import { ToastMsg } from "./TostMsg";
import ApiConfig, { FILE_BASE_URL } from "../api/ApiConfig";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import {
  DeleteCallWithErrorResponse,
  multipartPostCallWithErrorResponse,
  putMultipartWithAuthCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../api/ApiServices";
import { Pagination } from "./Pagination";
import FormLoader from "./FormLoader";


const Seerat = ({ key }) => {
  let module_id;
  let course_yr_id;
  let category_id;

  if (typeof window !== undefined) {
    module_id = localStorage.getItem("module_id");
    course_yr_id = localStorage.getItem("course_yr_id");
    category_id = localStorage.getItem("category_id");
  }

  const { sidebar, adminData } = useContext(AppContext);
  const [loader, setLoader] = useState(true);
  const [idEdit, setIdEdit] = useState("");
  const [imageWidth, setImageWidth] = useState({
    sabaqAudio: "100%",
    Uploade: "100%",
    Tarjama: "100%",
    Description: "100%",
    subSabaqTitle: "100%",
  });
  const [seeratList, setSeeratList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const startIndex = currentPage * 15;
  const endIndex = startIndex + 15;
  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };
  const pageCount = Math.ceil(seeratList?.length / 15);
  const [seerat, setSeerat] = useState({
    sabaqName: "",
    sabaqEnglish:"",
    sabaqHindi:"",
    sabaqUrdu:"",
    sabaqArabic:"",
    sabaqDesc: "",
    sabaqDescEnglish:"",
    sabaqDescHindi:"",
    sabaqDescUrdu:"",
    sabaqDescArabic:"",
    sabaqIcon: [],
    sabaqNameAudio: "",
    sabaqNameAudioEnglish:"",
    sabaqNameAudioArabic:"",
    sabaqDescAudio: "",
    sabaqDescAudioEnglish:"",
    sabaqDescAudioArabic:"",
    sabaqTeacherAudio:'',
    sabaqNameTeacherAudioEnglish:'',
    sabaqNameTeacherAudioArabic:'',
    sabaqTeacherDesc:"",
    sabaqDescTeacherAudioEnglish:"",
    sabaqDescTeacherAudioArabic:"",
    subSabaq: [
      {
        subSabaqTitle: "",
        subSabaqTitleEnglish:"",
        subSabaqTitleHindi:"",
        subSabaqTitleUrdu:"",
        subSabaqTitleArabic:"",
        subSabaqTitleAudio: "",
        subSabaqTitleAudioEnglish:"",
        subSabaqTitleAudioArabic:"",
        subSabaqDesc: "",
        subSabaqDescEnglish:"",
        subSabaqDescHindi:"",
        subSabaqDescUrdu:"",
        subSabaqDescArabic:"",
        subSabaqDescAudio: "",
        subSabaqDescAudioEnglish:"",
        subSabaqDescAudioArabic:"",
        teacherDescAudioPath:"",
        subSabaqDescTeacherAudioEnglish:"",
        subSabaqDescTeacherAudioArabic:"",
        titleTeacherAudioPath:"",
        subSabaqTitleTeacherAudioEnglish:"",
        subSabaqTitleTeacherAudioArabic:"",
      },
    ],
  });
  const [viewDetails, setViewDetails] = useState([]);
  const [add, setAdd] = useState(false);
  const handleAddClose = () => {
    setAdd(false)
    seeratListApi(11);
    setIdEdit("")
    setSeerat({
      sabaqName: "",
      sabaqEnglish:"",
      sabaqHindi:"",
      sabaqUrdu:"",
      sabaqArabic:"",
      sabaqDesc: "",
      sabaqDescEnglish:"",
      sabaqDescHindi:"",
      sabaqDescUrdu:"",
      sabaqDescArabic:"",
      sabaqNameAudio: "",
      sabaqNameAudioEnglish:"",
      sabaqNameAudioArabic:"",
      sabaqIcon: [],
      sabaqDescAudio: "",
      sabaqDescAudioEnglish:"",
      sabaqDescAudioArabic:"",
      sabaqTeacherAudio:'',
      sabaqNameTeacherAudioEnglish:'',
      sabaqNameTeacherAudioArabic:'',
      sabaqTeacherDesc:"",
      sabaqDescTeacherAudioEnglish:"",
      sabaqDescTeacherAudioArabic:"",
      subSabaq: [
        {
          subSabaqTitle: "",
          subSabaqTitleEnglish:"",
          subSabaqTitleHindi:"",
          subSabaqTitleUrdu:"",
          subSabaqTitleArabic:"",
          subSabaqDesc: "",
          subSabaqDescEnglish:"",
          subSabaqDescHindi:"",
          subSabaqDescUrdu:"",
          subSabaqDescArabic:"",
          subSabaqTitleAudio: "",
          subSabaqTitleAudioEnglish:"",
          subSabaqTitleAudioArabic:"",
          subSabaqDescAudio: "",
          subSabaqDescAudioEnglish:"",
          subSabaqDescAudioArabic:"",
          teacherDescAudioPath:"",
          subSabaqDescTeacherAudioEnglish:"",
          subSabaqDescTeacherAudioArabic:"",
          titleTeacherAudioPath:"",
          subSabaqTitleTeacherAudioEnglish:"",
          subSabaqTitleTeacherAudioArabic:"",
        },
      ],
    });
    setIdEdit("");
    setAdd(false);
  };
  const handleAddShow = () => setAdd(true);
  const [deleteId, setDeleteId] = useState("");
  const [deleteModal, setDelete] = useState(false);
  const handleDeleteClose = () => setDelete(false);
  const handleDeleteShow = () => setDelete(true);
  const [lasatSabaqId, setLsatSabaq] = useState("");
  const [saveBotton, setSaveBotton] = useState(false);

  const [viewModal, setView] = useState(false);
  const handleViewClose = () => setView(false);
  const handleViewShow = () => setView(true);

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      addSeeratApi();
    }
    setValidated(true);
  };
  //add
  const addSeeratApi = () => {
    setSaveBotton(true);
    // handleAddClose();
    setLoader(true);
    const body = {
      moduleId: module_id,
      courseYrId: (module_id === 1 || module_id === 2) && course_yr_id,
      categoryId: 11,
      userId: Number(adminData.user_id),
      sabaqNo: lasatSabaqId + 1,
      sabaqName: seerat.sabaqName ? seerat.sabaqName : "",
      sabaqEnglish: seerat.sabaqEnglish ? seerat.sabaqEnglish : "",
      sabaqHindi: seerat.sabaqHindi ? seerat.sabaqHindi : "",
      sabaqUrdu: seerat.sabaqUrdu ? seerat.sabaqUrdu : "",
      sabaqArabic: seerat.sabaqArabic ? seerat.sabaqArabic : "",
      sabaqDesc: seerat.sabaqDesc ? seerat.sabaqDesc : "",
      sabaqDescEnglish: seerat.sabaqDescEnglish ? seerat.sabaqDescEnglish : "",
      sabaqDescHindi: seerat.sabaqDescHindi ? seerat.sabaqDescHindi : "",
      sabaqDescUrdu: seerat.sabaqDescUrdu ? seerat.sabaqDescUrdu : "",
      sabaqDescArabic: seerat.sabaqDescArabic ? seerat.sabaqDescArabic : "",
      sabaqId: seerat.SabaqId,
      sabaqIcon: seerat.sabaqIcon,
      //  sabqId:lasatSabaqId
    };
    //all dataa paylodade

    let payLoadFormData = new FormData();
    payLoadFormData.append("moduleId", body.moduleId);
    payLoadFormData.append("courseYrId", course_yr_id);
    payLoadFormData.append("categoryId", body.categoryId);
    payLoadFormData.append("userId", body.userId);
    payLoadFormData.append("sabaqName", body.sabaqName);
    payLoadFormData.append("sabaqEnglish", body.sabaqEnglish);
    payLoadFormData.append("sabaqHindi", body.sabaqHindi);
    payLoadFormData.append("sabaqUrdu", body.sabaqUrdu);
    payLoadFormData.append("sabaqArabic", body.sabaqArabic);
    payLoadFormData.append("sabaqIcon", body.sabaqIcon ? body.sabaqIcon : "");
    payLoadFormData.append("sabaqDesc", body.sabaqDesc);
    payLoadFormData.append("sabaqDescEnglish", body.sabaqDescEnglish);
    payLoadFormData.append("sabaqDescHindi", body.sabaqDescHindi);
    payLoadFormData.append("sabaqDescUrdu", body.sabaqDescUrdu);
    payLoadFormData.append("sabaqDescArabic", body.sabaqDescArabic);

    idEdit === "edit"
      ? payLoadFormData.append("sabaqId", body.sabaqId)
      : payLoadFormData.append("sabaqNo", body.sabaqNo);
    // payLoadFormData.append("sabaqNo", body.sabaqNo)
    let subSabaq = seerat.subSabaq.map((ele, index) => {
      return {
        subSabaqDesc: ele.subSabaqDesc ? ele.subSabaqDesc : "",
        subSabaqDescEnglish: ele.subSabaqDescEnglish ? ele.subSabaqDescEnglish : "",
        subSabaqDescHindi: ele.subSabaqDescHindi ? ele.subSabaqDescHindi : "",
        subSabaqDescUrdu: ele.subSabaqDescUrdu ? ele.subSabaqDescUrdu : "",
        subSabaqDescArabic: ele.subSabaqDescArabic ? ele.subSabaqDescArabic : "",
        subSabaqNo: index + 1,
        subSabaqTitle: ele.subSabaqTitle ? ele.subSabaqTitle : "",
        subSabaqTitleEnglish: ele.subSabaqTitleEnglish ? ele.subSabaqTitleEnglish : "",
        subSabaqTitleHindi: ele.subSabaqTitleHindi ? ele.subSabaqTitleHindi : "",
        subSabaqTitleUrdu: ele.subSabaqTitleUrdu ? ele.subSabaqTitleUrdu : "",
        subSabaqTitleArabic: ele.subSabaqTitleArabic ? ele.subSabaqTitleArabic : "",
        subSabaqTitleAudio:
          ele.subSabaqTitleAudio == "" ? "no file" : "file name",
          subSabaqTitleAudioEnglish:
          ele.subSabaqTitleAudioEnglish == "" ? "no file" : "file name",
          subSabaqTitleAudioArabic:
          ele.subSabaqTitleAudioArabic == "" ? "no file" : "file name",    
        subSabaqDescAudio:
          ele.subSabaqDescAudio == "" ? "no file" : "file name",
             subSabaqDescAudioEnglish:
          ele.subSabaqDescAudioEnglish == "" ? "no file" : "file name",
             subSabaqDescAudioArabic:
          ele.subSabaqDescAudioArabic == "" ? "no file" : "file name",
          subSabaqTitleTeacherAudio:
          ele.titleTeacherAudioPath == "" ? "no file" : "file name",
           subSabaqTitleTeacherAudioEnglish:
          ele.subSabaqTitleTeacherAudioEnglish == "" ? "no file" : "file name",
           subSabaqTitleTeacherAudioArabic:
          ele.subSabaqTitleTeacherAudioArabic == "" ? "no file" : "file name",
          subSabaqDescTeacherAudio:
          ele.teacherDescAudioPath == "" ? "no file" : "file name",
            subSabaqDescTeacherAudioEnglish:
          ele.subSabaqDescTeacherAudioEnglish == "" ? "no file" : "file name",
            subSabaqDescTeacherAudioArabic:
          ele.subSabaqDescTeacherAudioArabic == "" ? "no file" : "file name",
      };
    });

    let subSabaqEdit = seerat.subSabaq.map((ele, index) => {
      return {
        subSabaqDesc: ele.subSabaqDesc ? ele.subSabaqDesc : "",
        subSabaqDescEnglish: ele.subSabaqDescEnglish ? ele.subSabaqDescEnglish : "",
        subSabaqDescHindi: ele.subSabaqDescHindi ? ele.subSabaqDescHindi : "",
        subSabaqDescUrdu: ele.subSabaqDescUrdu ? ele.subSabaqDescUrdu : "",
        subSabaqDescArabic: ele.subSabaqDescArabic ? ele.subSabaqDescArabic : "",
        subSabaqNo: index + 1,
        subSabaqId: ele.subSabaqId,
        subSabaqTitle: ele.subSabaqTitle ? ele.subSabaqTitle : "",
        subSabaqTitleEnglish: ele.subSabaqTitleEnglish ? ele.subSabaqTitleEnglish : "",
        subSabaqTitleHindi: ele.subSabaqTitleHindi ? ele.subSabaqTitleHindi : "",
        subSabaqTitleUrdu: ele.subSabaqTitleUrdu ? ele.subSabaqTitleUrdu : "",
        subSabaqTitleArabic: ele.subSabaqTitleArabic ? ele.subSabaqTitleArabic : "",
        subSabaqTitleAudio:
          typeof ele.subSabaqTitleAudio == "object" ? "updated" : "not updated",
          subSabaqTitleAudioEnglish:
          typeof ele.subSabaqTitleAudioEnglish == "object" ? "updated" : "not updated",
          subSabaqTitleAudioArabic:
          typeof ele.subSabaqTitleAudioArabic == "object" ? "updated" : "not updated",    
        subSabaqDescAudio:
          typeof ele.subSabaqDescAudio == "object" ? "updated" : "not updated",
            subSabaqDescAudioEnglish:
          typeof ele.subSabaqDescAudioEnglish == "object" ? "updated" : "not updated",
            subSabaqDescAudioArabic:
          typeof ele.subSabaqDescAudioArabic == "object" ? "updated" : "not updated",
          subSabaqTitleTeacherAudio:
          typeof ele.titleTeacherAudioPath == "object" ? "updated" : "not updated",
          subSabaqTitleTeacherAudioEnglish:
          typeof ele.subSabaqTitleTeacherAudioEnglish == "object" ? "updated" : "not updated",
          subSabaqTitleTeacherAudioArabic:
          typeof ele.subSabaqTitleTeacherAudioArabic == "object" ? "updated" : "not updated",
          subSabaqDescTeacherAudio:
          typeof ele.teacherDescAudioPath == "object" ? "updated" : "not updated",
          subSabaqDescTeacherAudioEnglish:
          typeof ele.subSabaqDescTeacherAudioEnglish == "object" ? "updated" : "not updated",
          subSabaqDescTeacherAudioArabic:
          typeof ele.subSabaqDescTeacherAudioArabic == "object" ? "updated" : "not updated",
      };
    });
    idEdit === "edit"
      ? payLoadFormData.append("subSabaq", JSON.stringify(subSabaqEdit))
      : payLoadFormData.append("subSabaq", JSON.stringify(subSabaq));

    let newSubaqAudio = [];
    newSubaqAudio.push(seerat.sabaqNameAudio);
    newSubaqAudio.map((ele) =>
      payLoadFormData.append("sabaqNameAudio", ele ? ele : "")
    );
    let sabaqNameAudioEnglish = [];
    sabaqNameAudioEnglish.push(seerat.sabaqNameAudioEnglish);
    sabaqNameAudioEnglish.map((ele) =>
      payLoadFormData.append("sabaqNameAudioEnglish", ele ? ele : "")
    );
    let sabaqNameAudioArabic = [];
    sabaqNameAudioArabic.push(seerat.sabaqNameAudioArabic);
    sabaqNameAudioArabic.map((ele) =>
      payLoadFormData.append("sabaqNameAudioArabic", ele ? ele : "")
    );
    //

    let newSubaqAudio2 = [];
    newSubaqAudio2.push(seerat.sabaqDescAudio);
    newSubaqAudio2.map((ele) =>
      payLoadFormData.append("sabaqDescAudio", ele ? ele : "")
    );
      let sabaqDescAudioEnglish = [];
    sabaqDescAudioEnglish.push(seerat.sabaqDescAudioEnglish);
    sabaqDescAudioEnglish.map((ele) =>
      payLoadFormData.append("sabaqDescAudioEnglish", ele ? ele : "")
    );
      let sabaqDescAudioArabic = [];
    sabaqDescAudioArabic.push(seerat.sabaqDescAudioArabic);
    sabaqDescAudioArabic.map((ele) =>
      payLoadFormData.append("sabaqDescAudioArabic", ele ? ele : "")
    );

    let newSubaqTeacrAudio = [];
    newSubaqTeacrAudio.push(seerat.sabaqTeacherAudio);
    newSubaqTeacrAudio.map((ele) =>
      payLoadFormData.append("sabaqNameTeacherAudio", ele ? ele : "")
    );

     let sabaqNameTeacherAudioEnglish = [];
    sabaqNameTeacherAudioEnglish.push(seerat.sabaqNameTeacherAudioEnglish);
    sabaqNameTeacherAudioEnglish.map((ele) =>
      payLoadFormData.append("sabaqNameTeacherAudioEnglish", ele ? ele : "")
    );

     let sabaqNameTeacherAudioArabic = [];
    sabaqNameTeacherAudioArabic.push(seerat.sabaqNameTeacherAudioArabic);
    sabaqNameTeacherAudioArabic.map((ele) =>
      payLoadFormData.append("sabaqNameTeacherAudioArabic", ele ? ele : "")
    );

    let newSubaqTeacrDescAudio = [];
    newSubaqTeacrDescAudio.push(seerat.sabaqTeacherAudio);
    newSubaqTeacrDescAudio.map((ele) =>
      payLoadFormData.append("sabaqDescTeacherAudio", ele ? ele : "")
    );
     let sabaqDescTeacherAudioEnglish = [];
    sabaqDescTeacherAudioEnglish.push(seerat.sabaqDescTeacherAudioEnglish);
    sabaqDescTeacherAudioEnglish.map((ele) =>
      payLoadFormData.append("sabaqDescTeacherAudioEnglish", ele ? ele : "")
    );
     let sabaqDescTeacherAudioArabic = [];
    sabaqDescTeacherAudioArabic.push(seerat.sabaqDescTeacherAudioArabic);
    sabaqDescTeacherAudioArabic.map((ele) =>
      payLoadFormData.append("sabaqDescTeacherAudioArabic", ele ? ele : "")
    );


    // console.log(seerat.subSabaq, "xvccagcgahs");
    seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqDescAudio",
        ele.subSabaqDescAudio ? ele.subSabaqDescAudio : ""
      )
    );
      seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqDescAudioEnglish",
        ele.subSabaqDescAudioEnglish ? ele.subSabaqDescAudioEnglish : ""
      )
    );
      seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqDescAudioArabic",
        ele.subSabaqDescAudioArabic ? ele.subSabaqDescAudioArabic : ""
      )
    );

    seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqTitleAudio",
        ele.subSabaqTitleAudio ? ele.subSabaqTitleAudio : ""
      )
    );
     
       seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqTitleAudioEnglish",
        ele.subSabaqTitleAudioEnglish ? ele.subSabaqTitleAudioEnglish : ""
      )
    );
   
       seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqTitleAudioArabic",
        ele.subSabaqTitleAudioArabic ? ele.subSabaqTitleAudioArabic : ""
      )
    );

    seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqTitleTeacherAudio",
        ele.titleTeacherAudioPath ? ele.titleTeacherAudioPath : ""
      )
    );
     seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqTitleTeacherAudioEnglish",
        ele.subSabaqTitleTeacherAudioEnglish ? ele.subSabaqTitleTeacherAudioEnglish : ""
      )
    );
     seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqTitleTeacherAudioArabic",
        ele.subSabaqTitleTeacherAudioArabic ? ele.subSabaqTitleTeacherAudioArabic : ""
      )
    );
    seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqDescTeacherAudio",
        ele.teacherDescAudioPath ? ele.teacherDescAudioPath : ""
      )
    );
     seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqDescTeacherAudioEnglish",
        ele.subSabaqDescTeacherAudioEnglish ? ele.subSabaqDescTeacherAudioEnglish : ""
      )
    );
     seerat.subSabaq.map((ele) =>
      payLoadFormData.append(
        "subSabaqDescTeacherAudioArabic",
        ele.subSabaqDescTeacherAudioArabic ? ele.subSabaqDescTeacherAudioArabic : ""
      )
    );
    // setIsLoading(true);
    idEdit === "edit"
      ? putMultipartWithAuthCallWithErrorResponse(
        ApiConfig.UPDATE_SABAQ_SECTION,
        payLoadFormData
      )
        .then((res) => {
          if (res.json && res.json?.success === true) {
            ToastMsg("success", res.json.message);
            seeratListApi();
            setSaveBotton(false);
            handleAddClose()
          } else {
            ToastMsg("error", res.json.message);
          }
        })
        .catch((err) => {
          setLoader(false);

          ToastMsg("error", "something went wrong");
        })
      : multipartPostCallWithErrorResponse(
        ApiConfig.ADD_SABAQ_SECTION,
        payLoadFormData
        // payLoadFormDataNew
      )
        .then((res) => {
          if (res.json && res.json?.success === true) {
            ToastMsg("success", res.json.message);
            seeratListApi();
            setSaveBotton(false);
                   handleAddClose()
          } else {
            ToastMsg("error", res.json.message);
          }
        })
        .catch((err) => {
          setLoader(false);

          ToastMsg("error", "something went wrong");
        });
  };
  //  list
  useEffect(() => {
    seeratListApi();
  }, [key]);
  const seeratListApi = () => {
    const apiUrl = (module_id == 1 || module_id == 2)
      ? ApiConfig.GET_ALL_SABAQ + `moduleId=${module_id}&courseYrId=${course_yr_id}&categoryId=${11}`
      : ApiConfig.GET_ALL_SABAQ + `moduleId=${module_id}&categoryId=${11}`;
    simpleGetCallWithErrorResponse(apiUrl)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setSeeratList(res.json.data?.allSabaq);
          setLsatSabaq(res.json?.data.allSabaq.length);
          // pagination();
          // ToastMsg("success", res.json.message);
        } else {
          // ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  const seeratLisDeleteApi = () => {
    const body = {
      categoryId: 11,

      sabaqId: deleteId,
    };
    // setIsLoading(true);
    DeleteCallWithErrorResponse(
      ApiConfig.DELETE_SABAQ_SECION,

      JSON.stringify({
        ...body,
      })
    )
      .then((res) => {
        setLoader(false);
        handleDeleteClose();
        if (res.json && res.json?.success === true) {
          seeratListApi();

          ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };
  //

  const EditListApi = (id) => {
    simpleGetCallWithErrorResponse(ApiConfig.VIEW_ALL_SABAQ + `sabaqId=${id}&categoryId=${category_id}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          // ToastMsg("success", res.json.message);
          let data = res.json?.data;
          setSeerat({
            SabaqId: data?.SabaqId,
            sabaqName: data?.sabaqName ? data?.sabaqName : "",
            sabaqEnglish: data?.sabaqEnglish ? data?.sabaqEnglish : "",
            sabaqHindi: data?.sabaqHindi ? data?.sabaqHindi : "",
            sabaqUrdu: data?.sabaqUrdu ? data?.sabaqUrdu : "",
            sabaqArabic: data?.sabaqArabic ? data?.sabaqArabic : "",
            sabaqDesc: data?.sabaqDesc ? data?.sabaqDesc : "",
            sabaqDescEnglish: data?.sabaqDescEnglish ? data?.sabaqDescEnglish : "",
            sabaqDescHindi: data?.sabaqDescHindi ? data?.sabaqDescHindi : "",
            sabaqDescUrdu: data?.sabaqDescUrdu ? data?.sabaqDescUrdu : "",
            sabaqDescArabic: data?.sabaqDescArabic ? data?.sabaqDescArabic : "",
            sabaqDescAudio: data?.sabaqDescAudio ? data?.sabaqDescAudio : "",
            sabaqDescAudioEnglish: data?.sabaqDescAudioEnglish ? data?.sabaqDescAudioEnglish : "",
            sabaqDescAudioArabic: data?.sabaqDescAudioArabic ? data?.sabaqDescAudioArabic : "",
            sabaqNameAudio: data?.sabaqAudio ? data?.sabaqAudio : "",
            sabaqNameAudioEnglish: data?.sabaqNameAudioEnglish ? data?.sabaqNameAudioEnglish : "",
            sabaqNameAudioArabic: data?.sabaqNameAudioArabic ? data?.sabaqNameAudioArabic : "",
            sabaqIcon: data?.sabaqIcon,
            sabaqTeacherAudio:data?.sabaqTeacherAudio ? data?.sabaqTeacherAudio : "",
            sabaqNameTeacherAudioEnglish:data?.sabaqNameTeacherAudioEnglish ? data?.sabaqNameTeacherAudioEnglish : "",
            sabaqNameTeacherAudioArabic:data?.sabaqNameTeacherAudioArabic ? data?.sabaqNameTeacherAudioArabic : "",
            sabaqTeacherDesc:data?.sabaqTeacherDesc ? data?.sabaqTeacherDesc : "",
            sabaqDescTeacherAudioEnglish:data?.sabaqDescTeacherAudioEnglish ? data?.sabaqDescTeacherAudioEnglish : "",
            sabaqDescTeacherAudioArabic:data?.sabaqDescTeacherAudioArabic ? data?.sabaqDescTeacherAudioArabic : "",
            subSabaq:
              data &&
              data.subSabaqs.map((ele, index) => {
                return {
                  subSabaqTitle: ele.subSabaqTitle ? ele.subSabaqTitle : "",
                  subSabaqTitleEnglish: ele.subSabaqTitleEnglish ? ele.subSabaqTitleEnglish : "",
                  subSabaqTitleHindi: ele.subSabaqTitleHindi ? ele.subSabaqTitleHindi : "",
                  subSabaqTitleUrdu: ele.subSabaqTitleUrdu ? ele.subSabaqTitleUrdu : "",
                  subSabaqTitleArabic: ele.subSabaqTitleArabic ? ele.subSabaqTitleArabic : "",
                  subSabaqTitleAudio: ele.titleAudioPath
                    ? ele.titleAudioPath
                    : "",
                   subSabaqTitleAudioEnglish: ele.subSabaqTitleAudioEnglish
                    ? ele.subSabaqTitleAudioEnglish
                    : "",
                   subSabaqTitleAudioArabic: ele.subSabaqTitleAudioArabic
                    ? ele.subSabaqTitleAudioArabic
                    : "",    
                  subSabaqDesc: ele.subSabaqDesc ? ele.subSabaqDesc : "",
                  subSabaqDescEnglish: ele.subSabaqDescEnglish ? ele.subSabaqDescEnglish : "",
                  subSabaqDescHindi: ele.subSabaqDescHindi ? ele.subSabaqDescHindi : "",
                  subSabaqDescUrdu: ele.subSabaqDescUrdu ? ele.subSabaqDescUrdu : "",
                  subSabaqDescArabic: ele.subSabaqDescArabic ? ele.subSabaqDescArabic : "",
                  subSabaqDescAudio: ele.descAudioPath ? ele.descAudioPath : "",
                  subSabaqDescAudioEnglish: ele.subSabaqDescAudioEnglish ? ele.subSabaqDescAudioEnglish : "",
                  subSabaqDescAudioArabic: ele.subSabaqDescAudioArabic ? ele.subSabaqDescAudioArabic : "",
                  titleTeacherAudioPath: ele.titleTeacherAudioPath ? ele.titleTeacherAudioPath : "",
                  subSabaqTitleTeacherAudioEnglish: ele.subSabaqTitleTeacherAudioEnglish ? ele.subSabaqTitleTeacherAudioEnglish : "",
                  subSabaqTitleTeacherAudioArabic: ele.subSabaqTitleTeacherAudioArabic ? ele.subSabaqTitleTeacherAudioArabic : "",
                  teacherDescAudioPath:ele.teacherDescAudioPath ? ele.teacherDescAudioPath : "",
                  subSabaqDescTeacherAudioEnglish:ele.subSabaqDescTeacherAudioEnglish ? ele.subSabaqDescTeacherAudioEnglish : "",
                  subSabaqDescTeacherAudioArabic:ele.subSabaqDescTeacherAudioArabic ? ele.subSabaqDescTeacherAudioArabic : "",
                  subSabaqId: ele.subSabaqId,
                  subSabaqNo: ele.subSabaqNo ? ele.subSabaqNo : "",
                };
              }),
          });

          handleAddShow();
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  //view the
  const viewDetailshandle = (id) => {
    simpleGetCallWithErrorResponse(ApiConfig.VIEW_SABAQ_SECTION + `sabaqId=${id}&categoryId=${category_id}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setViewDetails(res.json.data);
          handleViewShow();
          // ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Seerat</label>
        </div>
        <div className="add-btn">
          <button onClick={handleAddShow}>
            Add Sabaq
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div>
      </div>
      {/* ======================= START ADD ========================== */}
      <Modal
        show={add}
        onHide={() => handleAddClose()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton onHide={handleAddClose}>
          <Modal.Title>
            {idEdit === "edit" ? "Update  Seerat" : "Add Seerat"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} className="fw-bold" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name</Form.Label>
                <Form.Control
                  value={seerat?.sabaqName}
                  type="text"
                  required
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqName: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(English)</Form.Label>
                <Form.Control
                  value={seerat?.sabaqEnglish}
                  type="text"
                  required
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqEnglish: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(Hindi)</Form.Label>
                <Form.Control
                  value={seerat?.sabaqHindi}
                  type="text"
                  required
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqHindi: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(Urdu)</Form.Label>
                <Form.Control
                  value={seerat?.sabaqUrdu}
                  type="text"
                  required
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqUrdu: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(Arabic)</Form.Label>
                <Form.Control
                  value={seerat?.sabaqArabic}
                  type="text"
                  required
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqArabic: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
           

              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher And Student)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqNameAudio === "string"
                          ? seerat?.sabaqNameAudio.substring(
                            seerat?.sabaqNameAudio.length - 15,
                            seerat?.sabaqNameAudio.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqNameAudio: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher And Student)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqNameAudioEnglish === "string"
                          ? seerat?.sabaqNameAudioEnglish.substring(
                            seerat?.sabaqNameAudioEnglish.length - 15,
                            seerat?.sabaqNameAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqNameAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher And Student)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqNameAudioArabic === "string"
                          ? seerat?.sabaqNameAudioArabic.substring(
                            seerat?.sabaqNameAudioArabic.length - 15,
                            seerat?.sabaqNameAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqNameAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher And Student)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqNameAudio: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                 <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher And Student)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqNameAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                 <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher And Student)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqNameAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}
     {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqTeacherAudio === "string"
                          ? seerat?.sabaqTeacherAudio.substring(
                            seerat?.sabaqTeacherAudio.length - 15,
                            seerat?.sabaqTeacherAudio.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqTeacherAudio: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                    <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqNameTeacherAudioEnglish === "string"
                          ? seerat?.sabaqNameTeacherAudioEnglish.substring(
                            seerat?.sabaqNameTeacherAudioEnglish.length - 15,
                            seerat?.sabaqNameTeacherAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqNameTeacherAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                    <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqNameTeacherAudioArabic === "string"
                          ? seerat?.sabaqNameTeacherAudioArabic.substring(
                            seerat?.sabaqNameTeacherAudioArabic.length - 15,
                            seerat?.sabaqNameTeacherAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqNameTeacherAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqTeacherAudio: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                 <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqNameTeacherAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                 <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqNameTeacherAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}
              {/*{idEdit ? (
                <div>
                  <MDBRow>
                    <MDBCol lg="1" md="1" className="mb-4">
                      <img
                        src={
                          !seerat?.sabaqIcon
                            ? ""
                            : ApiConfig.FILE_BASE_URL + seerat?.sabaqIcon.length
                              ? ApiConfig.FILE_BASE_URL + seerat?.sabaqIcon
                              : ApiConfig.FILE_BASE_URL + seerat?.sabaqIcon &&
                              URL.createObjectURL(ApiConfig.FILE_BASE_URL + seerat?.sabaqIcon)

                        }
                        className="img-fluid rounded value"
                        alt=""
                      />
                    </MDBCol>
                  </MDBRow>
                  <div className="col-md-12 mb-3">
                    <Form.Label>Update Sabaq Icon</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      name="updateSabaqIcon"
                      onChange={(e) => {
                        setSeerat({
                          ...seerat,
                          sabaqIcon: e.target.files[0],
                        })
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Enter Sabaq Icon
                    </Form.Control.Feedback>
                  </div>
                </div>
              ) : (
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Icon</Form.Label>
                  <Form.Control
                    // required
                    type="file"
                    // accept="audio/mp3,audio/*;capture=microphone"
                    accept="image/*"
                    name="sabaqAudio"
                    src={seerat?.sabaqIcon}
                    //  / value={seerat?.sabaqAudio}
                    onChange={(e) => {
                      setSeerat({
                        ...seerat,
                        sabaqIcon: e.target.files[0],
                      })
                    }}
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Icon
                  </Form.Control.Feedback>
                </div>
              )}*/}


              <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description .</Form.Label>
                <Form.Control
                  as="textarea"
                  value={seerat?.sabaqDesc}
                  rows={3}
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqDesc: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Seerat Description.
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(English).</Form.Label>
                <Form.Control
                  as="textarea"
                  value={seerat?.sabaqDescEnglish}
                  rows={3}
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqDescEnglish: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Seerat Description.
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(Hindi).</Form.Label>
                <Form.Control
                  as="textarea"
                  value={seerat?.sabaqDescHindi}
                  rows={3}
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqDescHindi: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Seerat Description.
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(Urdu).</Form.Label>
                <Form.Control
                  as="textarea"
                  value={seerat?.sabaqDescUrdu}
                  rows={3}
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqDescUrdu: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Seerat Description.
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(Arabic).</Form.Label>
                <Form.Control
                  as="textarea"
                  value={seerat?.sabaqDescArabic}
                  rows={3}
                  onChange={(e) =>
                    setSeerat({ ...seerat, sabaqDescArabic: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Seerat Description.
                </Form.Control.Feedback>
              </div>


              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher And Student)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqDescAudio === "string"
                          ? seerat?.sabaqDescAudio.substring(
                            seerat?.sabaqDescAudio.length - 15,
                            seerat?.sabaqDescAudio.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqDescAudio: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                    <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher And Student)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqDescAudioEnglish === "string"
                          ? seerat?.sabaqDescAudioEnglish.substring(
                            seerat?.sabaqDescAudioEnglish.length - 15,
                            seerat?.sabaqDescAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqDescAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                    <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher And Student)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqDescAudioArabic === "string"
                          ? seerat?.sabaqDescAudioArabic.substring(
                            seerat?.sabaqDescAudioArabic.length - 15,
                            seerat?.sabaqDescAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqDescAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher And Student)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqDescAudio: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                   <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher And Student)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqDescAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                   <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher And Student)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqDescAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}
                 {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqTeacherDesc === "string"
                          ? seerat?.sabaqTeacherDesc.substring(
                            seerat?.sabaqTeacherDesc.length - 15,
                            seerat?.sabaqTeacherDesc.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqTeacherDesc: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqDescTeacherAudioEnglish === "string"
                          ? seerat?.sabaqDescTeacherAudioEnglish.substring(
                            seerat?.sabaqDescTeacherAudioEnglish.length - 15,
                            seerat?.sabaqDescTeacherAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqDescTeacherAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof seerat?.sabaqDescTeacherAudioArabic === "string"
                          ? seerat?.sabaqDescTeacherAudioArabic.substring(
                            seerat?.sabaqDescTeacherAudioArabic.length - 15,
                            seerat?.sabaqDescTeacherAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setSeerat({
                            ...seerat,
                            sabaqDescTeacherAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqTeacherDesc: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqDescTeacherAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setSeerat({
                        ...seerat,
                        sabaqDescTeacherAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}
              {seerat.subSabaq &&
                seerat.subSabaq.map((elementInArray, index) => {
                  return (
                    <>
                      <div
                        className="col-md-12 sub-group-main"
                        key={"testkey" + index}
                      >
                        <div className="row d-flex">
                        <div className="col-md-12">
                        <Form.Label> Sub Sabaq Title {index + 1}</Form.Label>
                        <Form.Control
                          value={elementInArray?.subSabaqTitle}
                          type="text"
                          onChange={(e) => {
                            setSeerat({
                              ...seerat,
                              subSabaq: seerat.subSabaq.map(
                                (item, innerIndex) => {
                                  return index === innerIndex
                                    ? {
                                      ...item,
                                      subSabaqTitle: e.target.value,
                                    }
                                    : item;
                                }
                              ),
                            });
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Sabaq Name
                        </Form.Control.Feedback>
                       </div>
                       </div>
                         <div className="row d-flex">
                        <div className="col-md-12">
                        <Form.Label> Sub Sabaq Title(English){index + 1}</Form.Label>
                        <Form.Control
                          value={elementInArray?.subSabaqTitleEnglish}
                          type="text"
                          onChange={(e) => {
                            setSeerat({
                              ...seerat,
                              subSabaq: seerat.subSabaq.map(
                                (item, innerIndex) => {
                                  return index === innerIndex
                                    ? {
                                      ...item,
                                      subSabaqTitleEnglish: e.target.value,
                                    }
                                    : item;
                                }
                              ),
                            });
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Sabaq Name
                        </Form.Control.Feedback>
                       </div>
                       </div>
                         <div className="row d-flex">
                        <div className="col-md-12">
                        <Form.Label> Sub Sabaq Title(Hindi){index + 1}</Form.Label>
                        <Form.Control
                          value={elementInArray?.subSabaqTitleHindi}
                          type="text"
                          onChange={(e) => {
                            setSeerat({
                              ...seerat,
                              subSabaq: seerat.subSabaq.map(
                                (item, innerIndex) => {
                                  return index === innerIndex
                                    ? {
                                      ...item,
                                      subSabaqTitleHindi: e.target.value,
                                    }
                                    : item;
                                }
                              ),
                            });
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Sabaq Name
                        </Form.Control.Feedback>
                       </div>
                       </div>
                         <div className="row d-flex">
                        <div className="col-md-12">
                        <Form.Label> Sub Sabaq Title(Urdu){index + 1}</Form.Label>
                        <Form.Control
                          value={elementInArray?.subSabaqTitleUrdu}
                          type="text"
                          onChange={(e) => {
                            setSeerat({
                              ...seerat,
                              subSabaq: seerat.subSabaq.map(
                                (item, innerIndex) => {
                                  return index === innerIndex
                                    ? {
                                      ...item,
                                      subSabaqTitleUrdu: e.target.value,
                                    }
                                    : item;
                                }
                              ),
                            });
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Sabaq Name
                        </Form.Control.Feedback>
                       </div>
                       </div>
                         <div className="row d-flex">
                        <div className="col-md-12">
                        <Form.Label> Sub Sabaq Title(Arabic){index + 1}</Form.Label>
                        <Form.Control
                          value={elementInArray?.subSabaqTitleArabic}
                          type="text"
                          onChange={(e) => {
                            setSeerat({
                              ...seerat,
                              subSabaq: seerat.subSabaq.map(
                                (item, innerIndex) => {
                                  return index === innerIndex
                                    ? {
                                      ...item,
                                      subSabaqTitleArabic: e.target.value,
                                    }
                                    : item;
                                }
                              ),
                            });
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Sabaq Name
                        </Form.Control.Feedback>
                       </div>
                       </div>
                        {idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher And Student)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleAudio ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleAudio.substring(
                                      elementInArray?.subSabaqTitleAudio
                                        .length - 15,
                                      elementInArray?.subSabaqTitleAudio
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setSeerat({
                                      ...seerat,
                                      subSabaq: seerat.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleAudio:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                             <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher And Student)(English)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleAudioEnglish ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleAudioEnglish.substring(
                                      elementInArray?.subSabaqTitleAudioEnglish
                                        .length - 15,
                                      elementInArray?.subSabaqTitleAudioEnglish
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitleAudioEnglish }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setSeerat({
                                      ...seerat,
                                      subSabaq: seerat.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleAudioEnglish:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                             <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher And Student)(Arabic)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleAudioArabic ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleAudioArabic.substring(
                                      elementInArray?.subSabaqTitleAudioArabic
                                        .length - 15,
                                      elementInArray?.subSabaqTitleAudioArabic
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitleAudioArabic }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setSeerat({
                                      ...seerat,
                                      subSabaq: seerat.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleAudioArabic:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                          <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher And Student)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setSeerat({
                                  ...seerat,
                                  subSabaq: seerat.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleAudio:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                             <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher And Student)(English)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setSeerat({
                                  ...seerat,
                                  subSabaq: seerat.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleAudioEnglish:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                             <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher And Student)(Arabic)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setSeerat({
                                  ...seerat,
                                  subSabaq: seerat.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleAudioArabic:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          </>
                        )}
                           {idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.titleTeacherAudioPath ===
                                    "string"
                                    ? elementInArray?.titleTeacherAudioPath.substring(
                                      elementInArray?.titleTeacherAudioPath
                                        .length - 15,
                                      elementInArray?.titleTeacherAudioPath
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setSeerat({
                                      ...seerat,
                                      subSabaq: seerat.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              titleTeacherAudioPath:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher)(English)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleTeacherAudioEnglish ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleTeacherAudioEnglish.substring(
                                      elementInArray?.subSabaqTitleTeacherAudioEnglish
                                        .length - 15,
                                      elementInArray?.subSabaqTitleTeacherAudioEnglish
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitleTeacherAudioEnglish }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setSeerat({
                                      ...seerat,
                                      subSabaq: seerat.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleTeacherAudioEnglish:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher)(Arabic)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleTeacherAudioArabic ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleTeacherAudioArabic.substring(
                                      elementInArray?.subSabaqTitleTeacherAudioArabic
                                        .length - 15,
                                      elementInArray?.subSabaqTitleTeacherAudioArabic
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitleTeacherAudioArabic }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setSeerat({
                                      ...seerat,
                                      subSabaq: seerat.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleTeacherAudioArabic:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                          <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setSeerat({
                                  ...seerat,
                                  subSabaq: seerat.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          titleTeacherAudioPath:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                           <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher)(English)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setSeerat({
                                  ...seerat,
                                  subSabaq: seerat.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleTeacherAudioEnglish:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                           <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher)(Arabic)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setSeerat({
                                  ...seerat,
                                  subSabaq: seerat.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleTeacherAudioArabic:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          </>
                        )}
                        <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDesc}
                            onChange={(e) => {
                              setSeerat({
                                ...seerat,
                                subSabaq: seerat.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDesc: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Seerat Description .
                          </Form.Control.Feedback>
                        </div>
                           <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Description(English)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescEnglish}
                            onChange={(e) => {
                              setSeerat({
                                ...seerat,
                                subSabaq: seerat.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescEnglish: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Seerat Description .
                          </Form.Control.Feedback>
                        </div>
                          <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Description(Hindi)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescHindi}
                            onChange={(e) => {
                              setSeerat({
                                ...seerat,
                                subSabaq: seerat.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescHindi: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Seerat Description .
                          </Form.Control.Feedback>
                        </div>
                          <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Description(Urdu)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescUrdu}
                            onChange={(e) => {
                              setSeerat({
                                ...seerat,
                                subSabaq: seerat.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescUrdu: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Seerat Description .
                          </Form.Control.Feedback>
                        </div>
                           <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Description(Arabic)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescArabic}
                            onChange={(e) => {
                              setSeerat({
                                ...seerat,
                                subSabaq: seerat.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescArabic: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Seerat Description .
                          </Form.Control.Feedback>
                        </div>

                        <>
                          {idEdit ? (
                            <>
                              <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher And Student)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescAudio ===
                                      "string"
                                      ? elementInArray?.subSabaqDescAudio.substring(
                                        elementInArray?.subSabaqDescAudio
                                          .length - 15,
                                        elementInArray?.subSabaqDescAudio
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setSeerat({
                                        ...seerat,
                                        subSabaq: seerat.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescAudio:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                               <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher And Student)(English)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescAudioEnglish ===
                                      "string"
                                      ? elementInArray?.subSabaqDescAudioEnglish.substring(
                                        elementInArray?.subSabaqDescAudioEnglish
                                          .length - 15,
                                        elementInArray?.subSabaqDescAudioEnglish
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setSeerat({
                                        ...seerat,
                                        subSabaq: seerat.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescAudioEnglish:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                               <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher And Student)(Arabic)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescAudioArabic ===
                                      "string"
                                      ? elementInArray?.subSabaqDescAudioArabic.substring(
                                        elementInArray?.subSabaqDescAudioArabic
                                          .length - 15,
                                        elementInArray?.subSabaqDescAudioArabic
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setSeerat({
                                        ...seerat,
                                        subSabaq: seerat.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescAudioArabic:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                            <div className="col-md-12 mb-3">
                              <Form.Label>
                                {" "}
                                Sub Sabaq Description Audio(Teacher And Student)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setSeerat({
                                    ...seerat,
                                    subSabaq: seerat.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescAudio:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                              <div className="col-md-12 mb-3">
                              <Form.Label>
                                {" "}
                                Sub Sabaq Description Audio(Teacher And Student)(English)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setSeerat({
                                    ...seerat,
                                    subSabaq: seerat.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescAudioEnglish:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                              <div className="col-md-12 mb-3">
                              <Form.Label>
                                {" "}
                                Sub Sabaq Description Audio(Teacher And Student)(Arabic)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setSeerat({
                                    ...seerat,
                                    subSabaq: seerat.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescAudioArabic:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                            </>
                          )}
                          {idEdit ? (
                            <>
                              <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.teacherDescAudioPath ===
                                      "string"
                                      ? elementInArray?.teacherDescAudioPath.substring(
                                        elementInArray?.teacherDescAudioPath
                                          .length - 15,
                                        elementInArray?.teacherDescAudioPath
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setSeerat({
                                        ...seerat,
                                        subSabaq: seerat.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                teacherDescAudioPath:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                              <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher)(English)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescTeacherAudioEnglish ===
                                      "string"
                                      ? elementInArray?.subSabaqDescTeacherAudioEnglish.substring(
                                        elementInArray?.subSabaqDescTeacherAudioEnglish
                                          .length - 15,
                                        elementInArray?.subSabaqDescTeacherAudioEnglish
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setSeerat({
                                        ...seerat,
                                        subSabaq: seerat.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescTeacherAudioEnglish:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                              <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher)(Arabic)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescTeacherAudioArabic ===
                                      "string"
                                      ? elementInArray?.subSabaqDescTeacherAudioArabic.substring(
                                        elementInArray?.subSabaqDescTeacherAudioArabic
                                          .length - 15,
                                        elementInArray?.subSabaqDescTeacherAudioArabic
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setSeerat({
                                        ...seerat,
                                        subSabaq: seerat.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescTeacherAudioArabic:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                            <div className="col-md-12 mb-3">
                              <Form.Label>
                                {" "}
                                Sub Sabaq Description Audio(Teacher)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setSeerat({
                                    ...seerat,
                                    subSabaq: seerat.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            teacherDescAudioPath:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                             <div className="col-md-12 mb-3">
                              <Form.Label>
                                {" "}
                                Sub Sabaq Description Audio(Teacher)(English)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setSeerat({
                                    ...seerat,
                                    subSabaq: seerat.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescTeacherAudioEnglish:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                             <div className="col-md-12 mb-3">
                              <Form.Label>
                                {" "}
                                Sub Sabaq Description Audio(Teacher)(Arabic)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setSeerat({
                                    ...seerat,
                                    subSabaq: seerat.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescTeacherAudioArabic:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                            </>
                          )}
                        </>
                        <div className=" text-end mb-3">
                          <Link
                            to="#"
                            // className="btn btn-danger"
                            // onClick={() =>
                            //   setaddDescription(addDescription - 1)
                            // }
                            className={
                              seerat.subSabaq.length > 1
                                ? "btn btn-danger"
                                : "btn btn-secondary invisible"
                            }
                            onClick={() => {
                              if (seerat.subSabaq.length > 1) {
                                // seerat.subSabaq.splice(index, 1);
                                const copySubDeatails = [...seerat.subSabaq];
                                copySubDeatails.splice(index, 1);
                                setSeerat({
                                  ...seerat,
                                  subSabaq: copySubDeatails,
                                });
                              }

                              // const copySubDeatails = [...addSabaq.subsabaqDetails];
                              // copySubDeatails.sli
                            }}
                          >
                            Remove
                          </Link>
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>

            <Link
              to="#"
              className={
                // idEdit
                //   ? "add-newSabaq-btn invisible btn btn-secondary pe-none"
                //   :
                "add-newSabaq-btn btn btn-primary"
              }
              // onClick={() => setaddDescription(addDescription + 1)}
              onClick={() => {
                let sirat = [
                  ...seerat.subSabaq,

                  {
                    subSabaqTitle: "",
                    subSabaqTitleEnglish:"",
                    subSabaqTitleHindi:"",
                    subSabaqTitleUrdu:"",
                    subSabaqTitleArabic:"",
                    subSabaqDesc: "",
                    subSabaqDescEnglish:"",
                    subSabaqDescHindi:"",
                    subSabaqDescUrdu:"",
                    subSabaqDescArabic:"",
                    subSabaqTitleAudio: "",
                    subSabaqTitleAudioEnglish:"",
                    subSabaqTitleAudioArabic:"",
                    subSabaqDescAudio: "",
                    subSabaqDescAudioEnglish:"",
                    subSabaqDescAudioArabic:"",
                    titleTeacherAudioPath:"",
                    subSabaqTitleTeacherAudioEnglish:"",
                    subSabaqTitleTeacherAudioArabic:"",
                    teacherDescAudioPath:"",
                    subSabaqDescTeacherAudioEnglish:"",
                    subSabaqDescTeacherAudioArabic:"",
                  },
                ];
                setSeerat({
                  ...seerat,
                  subSabaq: sirat,
                });
              }}
            >
              {" "}
              + Add Sub Sabaq Details
            </Link>
            <div className="buttons-modal m-2 border-top pt-3 text-end ">
              <button className="me-2" type="submit" >
                {idEdit === "edit" ? "update" : "Save"}
              </button>
              <Link
                to="#"
                className=" bg-danger"
                onClick={() => {
                  setSeerat({
                    sabaqName: "",
                    sabaqEnglish:"",
                    sabaqHindi:"",
                    sabaqUrdu:"",
                    sabaqArabic:"",
                    sabaqNameAudio: "",
                    sabaqNameAudioEnglish:"",
                    sabaqNameAudioArabic:"",
                    subSabaq: [
                      {
                        subSabaqTitle: "",
                        subSabaqTitleEnglish:"",
                        subSabaqTitleHindi:"",
                        subSabaqTitleUrdu:"",
                        subSabaqTitleArabic:"",
                        subSabaqDesc: "",
                        subSabaqDescEnglish:"",
                        subSabaqDescHindi:"",
                        subSabaqDescUrdu:"",
                        subSabaqDescArabic:"",
                        subSabaqTitleAudio: "",
                        subSabaqTitleAudioEnglish:"",
                        subSabaqTitleAudioArabic:"",
                        subSabaqDescAudio: "",
                        subSabaqDescAudioEnglish:"",
                        subSabaqDescAudioArabic:"",
                      },
                    ],
                  });
                  handleAddClose();
                  setIdEdit("");
                }}
              >
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END ADD ========================== */}

      {/* ======================= DELETE ========================== */}

      <Modal
        show={deleteModal}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Are you sure you want to delete this item?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 bg-danger"
              type="submit"
              onClick={() => {
                handleDeleteClose();
                seeratLisDeleteApi();
              }}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
      {/* ======================= END DELETE ========================== */}

      {/* ======================= VIEW ========================== */}
      <Modal
        show={viewModal}
        onHide={handleViewClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Sabaq Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq No.
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails.SabaqNo}
                  </label>
                </div>
              </div>

              {/* sabaqicon */}
              <div className="col-md-6 mb-3">
                {/* <div>
                    <label htmlFor="" className="key">
                      Sabaq Icon
                    </label>
                  </div>
                  <div>
                    <MDBRow>
                      <MDBCol lg="2" md="3" className="mb-4">
                        <img
                          src={
                            !viewDetails?.sabaqIcon
                              ? ""
                              : ApiConfig.FILE_BASE_URL +
                                viewDetails?.sabaqIcon.length
                              ? ApiConfig.FILE_BASE_URL + viewDetails?.sabaqIcon
                              : ApiConfig.FILE_BASE_URL +
                                  viewDetails?.sabaqIcon &&
                                URL.createObjectURL(
                                  ApiConfig.FILE_BASE_URL +
                                    viewDetails?.sabaqIcon
                                )
                          }
                          className="img-fluid rounded value"
                          alt=""
                        />
                      </MDBCol>
                    </MDBRow>
                  </div> */}
              </div>
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name.
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails.sabaqName}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(English)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails.sabaqEnglish}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(Hindi)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails.sabaqHindi}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(Urdu)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails.sabaqUrdu}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(Arabic)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails.sabaqArabic}
                  </label>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher And Student)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqAudio ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqAudio}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqAudio}`} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher And Student)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqNameAudioEnglish}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqNameAudioEnglish}`} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher And Student)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqNameAudioArabic}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqNameAudioArabic}`} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
              <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqTeacherAudio ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqTeacherAudio}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqTeacherAudio}`} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
               <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameTeacherAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqNameTeacherAudioEnglish}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqNameTeacherAudioEnglish}`} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
               <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameTeacherAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqNameTeacherAudioArabic}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqNameTeacherAudioArabic}`} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description.
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDesc}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description(English).
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescEnglish}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description(Hindi).
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescHindi}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description(Urdu).
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescUrdu}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description(Arabic).
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescArabic}
                  </label>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher And Student)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescAudio ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqDescAudio}`} type="audio/ogg" />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails.sabaqDescAudio}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher And Student)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqDescAudioEnglish}`} type="audio/ogg" />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails.sabaqDescAudioEnglish}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher And Student)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqDescAudioArabic}`} type="audio/ogg" />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails.sabaqDescAudioArabic}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
              <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqTeacherDesc ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqTeacherDesc}`} type="audio/ogg" />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails.sabaqTeacherDesc}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
                           <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescTeacherAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqDescTeacherAudioEnglish}`} type="audio/ogg" />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails.sabaqDescTeacherAudioEnglish}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
                           <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescTeacherAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails.sabaqDescTeacherAudioArabic}`} type="audio/ogg" />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails.sabaqDescTeacherAudioArabic}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>

              <h5 className="fw-bold">Sub Sabaq Details</h5>

              {viewDetails &&
                viewDetails.subSabaqs &&
                viewDetails.subSabaqs.map((ele, index) => {
                  return (
                    <div
                      className="sub-group-main row"
                      key={"testkey121" + index}
                    >
                      <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Title {ele.subSabaqNo}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitle}
                          </label>
                        </div>
                      </div>
                          <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Title(English){ele.subSabaqNo}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleEnglish}
                          </label>
                        </div>
                      </div>
                          <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Title(Hindi){ele.subSabaqNo}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleHindi}
                          </label>
                        </div>
                      </div>
                          <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Title(Urdu){ele.subSabaqNo}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleUrdu}
                          </label>
                        </div>
                      </div>
                          <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Title(Arabic){ele.subSabaqNo}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleArabic}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Title Audio(Teacher And Student)
                          </label>
                        </div>
                        <div>
                          {ele?.titleAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.titleAudioPath}`} type="audio/ogg" />
                              <source
                                src={`${FILE_BASE_URL}${ele.titleAudioPath}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Title Audio(Teacher And Student)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqTitleAudioEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioEnglish}`} type="audio/ogg" />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioEnglish}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Title Audio(Teacher And Student)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqTitleAudioArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioArabic}`} type="audio/ogg" />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioArabic}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Title Audio(Teacher)
                          </label>
                        </div>
                        <div>
                          {ele?.titleTeacherAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.titleTeacherAudioPath}`} type="audio/ogg" />
                              <source
                                src={`${FILE_BASE_URL}${ele.titleTeacherAudioPath}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Title Audio(Teacher)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqTitleTeacherAudioEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioEnglish}`} type="audio/ogg" />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioEnglish}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Title Audio(Teacher)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqTitleTeacherAudioArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioArabic}`} type="audio/ogg" />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioArabic}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Description
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDesc}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Description(English)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescEnglish}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Description(Hindi)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescHindi}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Description(Urdu)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescUrdu}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            sub Sabaq Description(Arabic)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescArabic}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Description Audio(Teacher And Student)
                          </label>
                        </div>
                        <div>
                          {ele?.descAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.descAudioPath}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.descAudioPath}`} type="audio/mpeg" />
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Description Audio(Teacher And Student)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescAudioEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescAudioEnglish}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescAudioEnglish}`} type="audio/mpeg" />
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Description Audio(Teacher And Student)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescAudioArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescAudioArabic}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescAudioArabic}`} type="audio/mpeg" />
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Description Audio(Teacher)
                          </label>
                        </div>
                        <div>
                          {ele?.teacherDescAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.teacherDescAudioPath}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.teacherDescAudioPath}`} type="audio/mpeg" />
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Description Audio(Teacher)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescTeacherAudioEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescTeacherAudioEnglish}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescTeacherAudioEnglish}`} type="audio/mpeg" />
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            sub Sabaq Description Audio(Teacher)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescTeacherAudioArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescTeacherAudioArabic}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescTeacherAudioArabic}`} type="audio/mpeg" />
                            </audio>
                          ) : ("")}

                        </div>
                        
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              {/* <button className="me-2" type="submit">
                Save
              </button> */}
              <Link to="#" className="bg-danger" onClick={handleViewClose}>
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END VIEW ========================== */}

      {loader ? (
        <FormLoader />
      ) : (
        <div className="table-wrapper">
          <h6>Total Records : {seeratList.length}</h6>
          <Table className="display" striped bordered hover size="lg">
            <thead className="text-center">
              <tr>
                <th>Sabaq No.</th>
                <th
                // style={{ textAlign: "left" }}
                >Seerat List</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {seeratList && seeratList.length > 0
                ? seeratList.slice(startIndex, endIndex).map((ele, index) => {
                  return (
                    <tr key={"testkeylist" + index}>
                      <td>{index + 1 + startIndex}</td>

                      <td style={{ textAlign: "left" }}>{ele.sabaqName}</td>
                      <td className="action">
                        <Link
                          to="#"
                          className="icon edit"
                          onClick={() => {
                            // handleAddShow();
                            setIdEdit("edit");
                            setImageWidth({
                              ...imageWidth,
                              sabaqAudio: "117px",
                              Uploade: "117px",
                              Tarjama: "117px",
                              Description: "117px",
                              subSabaqTitle: "117px",
                            });
                            EditListApi(ele.sabaqId);
                          }}
                        >
                          <img src={ic_edit} alt="" />
                        </Link>
                        <Link
                          to="#"
                          className="icon view"
                          onClick={() => viewDetailshandle(ele.sabaqId)}
                        >
                          <img src={ic_eyes} alt="" />
                        </Link>
                        <Link
                          to="#"
                          className="icon delete"
                          onClick={() => {
                            handleDeleteShow();
                            setDeleteId(ele.sabaqId);
                          }}
                        >
                          <img src={ic_delete} alt="" />
                        </Link>
                      </td>
                    </tr>
                  );
                })
                : ""}
            </tbody>
          </Table>
          {seeratList && seeratList.length > 0 ? (
            <Pagination
              changePage={changePage}
              pageCount={pageCount}
              currentPage={currentPage}
            />
          ) : (
            <div>
              <h5 style={{ color: "red", textAlign: "center" }}>
                {" "}
                Records Not Found
              </h5>
            </div>
          )}
        </div>
      )}
    </main>
  );
};

export default Seerat;
